<template>
  <div>
    <v-card>
      <v-data-table
        :headers="
          type == 'response'
            ? responseDocumentHeader
            : this.$store.getters.tradeRequestIsEdit &&
              this.$store.getters.tradeRequestEditMode
            ? itemsTableFieldsMoreDetail
            : itemsTableFields
        "
        :items="items"
        tableClasses="item-table border"
        disable-pagination
        responsive
        hide-default-footer
        fixed-header
        max-height="200"
        item-key="title"
      >
        <template v-slot:[`item.indexImage`]="{ item }">
          <v-img
            v-if="item.fileId && item.fileId.thumbnailFileUrl"
            :src="item.fileId.thumbnailFileUrl"
            width="50px"
            height="50px"
          />
        </template>
        <template v-slot:[`item.description`]="{ item }">
          {{
            item.description
              ? item.description.length > 30
                ? item.description.slice(0, 30) + '...'
                : item.description
              : 'وارد نشده'
          }}
        </template>
        <template v-slot:[`item.isOptional`]="{ item }">
          {{ item.isOptional ? 'اختیاری' : 'اجباری' }}
        </template>
        <template v-slot:[`item.operations`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="$emit('removeAttachedItem', item)">
                <v-icon color="error" dark v-bind="attrs" v-on="on">
                  mdi-trash-can
                </v-icon>
              </v-btn>
            </template>
            <span>حذف</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              type == 'upload' &&
              item &&
              item.fileType != 'application/pdf' &&
              item.fileType != '.pdf'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="
                  $emit('addToDefault', item);
                  log(item);
                "
              >
                <v-icon
                  :color="item.isDefault ? 'green' : ''"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-cursor-default-click
                </v-icon>
              </v-btn>
            </template>
            <span>انتخاب برای تصویر پیش فرض</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TradeRequestInventoryItemsList',
  props: {
    items: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      responseDocumentHeader: [
        {
          value: 'isOptional',
          text: 'اختیار الصاق',
          sortable: true,
        },
        {
          value: 'documentTypeTitle',
          text: 'عنوان اصلی ',
          sortable: true,
        },
        {
          value: 'subTitle',
          text: 'عنوان دلخواه',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],
      itemsTableFieldsMoreDetail: [
        {
          value: 'indexImage',
          text: 'نشانگر فایل آپلود شده',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'documentTypeTitle',
          text: 'نوع مدرک',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],
      itemsTableFields: [
        {
          value: 'type',
          text: 'نوع مدرک',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'fileSize',
          text: 'سایز',
          sortable: true,
        },
        {
          value: 'fileType',
          text: 'فرمت فایل',
          sortable: true,
        },

        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],
    };
  },
  watch: {
    selected() {
      this.$emit('selectedItem', this.selected);
    },
  },
  methods: {
    log(item) {
      console.log(item);
    },
  },
};
</script>

<style></style>
